import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    ballot: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setBallot(state, payload) {
      state.ballot = payload.list;
      state.totalCount = payload.totalCount;
    }
  },
  actions: {
    getaward({ commit }, data) {
      return api.getaward(data).then(({ data }) => {
        commit('setBallot', data);
      });
    },
    confirmGitNum(context, data) {
      return api.confirmGitNum(data);
    },
    confirmOne(context, data) {
      return api.confirmOne(data);
    },
    confirconfirmMoremGitNum(context, data) {
      return api.confirmMore(data);
    }
  }
};

appStore.registerModule('discountrecord', store);
